import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { DoublePanelViewLayout } from 'layouts/DoublePanelViewLayout'
import useQueryParams from 'utils/hooks/useQueryParams'
import LinkForm from 'modules/Forms/Referral/LinkForm'
import { useReferralLinks } from 'modules/Referral/ReferralLinks/hooks/useReferralLinks'
import { toFixedIfNecessary } from 'utils/toFixedIfNecessary'

const EditLink = () => {
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const { fetchLink } = useReferralLinks()
  const [data, setData] = useState(null)
  const {
    query: { goBack },
  } = useQueryParams()

  const { linkId = null } = useParams()

  useEffect(() => {
    if (!linkId) {
      return
    }
    fetchLink({ id: linkId }).then(({ data }) => {
      setData({
        ...data,
        settings:
          data?.settings?.map(
            (
              { total_percent, partner_percent, client_percent, ...rest },
              index,
            ) => ({
              ...rest,
              total_percent: +toFixedIfNecessary(total_percent),
              partner_percent: +toFixedIfNecessary(partner_percent),
              client_percent: +toFixedIfNecessary(client_percent),
              index,
            }),
          ) ?? [],
      })
    })
  }, [linkId])

  if (!fetchLink.finished || !data) {
    return null
  }

  return (
    <DoublePanelViewLayout
      onClose={(e) => {
        e.preventDefault()
        history.push(goBack ?? pathGen(ROUTES.REFERRAL_LINKS))
      }}
    >
      <LinkForm
        id={linkId}
        {...data}
        onClose={() => history.push(goBack ?? pathGen(ROUTES.REFERRAL_LINKS))}
      />
    </DoublePanelViewLayout>
  )
}

export default EditLink
